import { Skelton } from 'library/skelton';

const NotificationLoading = () => {
    return (
        <div className="divide-y divide-separator-color-light mt-2">
            {Array.from(Array(4).keys()).map((row) => (
                <div key={row} className="relative flex gap-3 px-4 py-4 cursor-pointer">
                    <div>
                        <Skelton variant="circular" width="40px" height="40px" />
                    </div>

                    <div className="text-sm w-full pr-6 overflow-hidden">
                        <div>
                            <Skelton width="100%" />
                        </div>
                        <div className="text-xs text-grayscale-500 mt-1">
                            <Skelton width="30%" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NotificationLoading;
